import shuffle from 'shuffle-array'

export default class Deck {
	/**
	 * @param {Object<string, number>} quantity
	 * @param {number} marketSize
	 */
	constructor(quantity, marketSize = 10) {
		const CardTypes = {}
		this.cards = []
		this.ownedCards = []
		this.market = []
		this.marketSize = marketSize

		for(let cardName of Object.keys(quantity)) {
			CardTypes[cardName] = require(`./cards/${cardName.replace(/[^\w]/g, '')}`).default

			for(let i = 0; i < quantity[cardName]; i++)
				this.cards.push(new CardTypes[cardName])
		}

		shuffle(this.cards)
	}

	/**
	 * Fills the market with cards
	 * @returns {Card[]} the market generated
	 */
	updateMarket() {
		if(this.market.length < this.marketSize)
			while(this.cards.length) {
				let unique = this.market.filter((value, index, array) => {
					for(let i = 0; i < index; i++)
						if(array[i].name === value.name)
							return false
					return true
				})

				// push and don't look
				if(unique.length < this.marketSize)
					this.market.push(this.cards.shift())

				// stop
				if(unique.length === this.marketSize)
					break

				// went too far
				if(unique.length > this.marketSize)
					this.cards.unshift(this.market.pop())
			}

		return this.market
	}

	/**
	 * Buys the Nth card on the market
	 * @param {number|number[]} index
	 * @param {Player} player
	 * @return {Card[]}
	 */
	buy(index, player) {
		let ret = []
		let retIndex = []
		if(typeof index === 'number')
			index = [index]

		for(let i of index)
			if(player.buyCard(this.market[i]))
				retIndex.push(i)

		// save card as owned in reverse order to keep key importance
		for(let i of retIndex.sort().reverse()) {
			let card = this.market.splice(i, 1)
			this.ownedCards.push(card[0])
			ret.push(card[0])
		}

		return ret
	}
}
